import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Create root and render App
ReactDOM.createRoot(document.getElementById('root')).render(
    <App />
);

// Report web vitals (performance)
reportWebVitals();